<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 清除默认边距，让大屏铺满全屏 */
* {
  margin: 0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
  /* overflow: hidden; */ /* 这样设置会隐藏滚动条，导致移动端无法滚动 */
}
</style>